import api from "./index";
import axios from "axios"; // utilizada para header personalizado na requisição externa do L+
import generateHeaders from "../utils/generateHeaders.js";

/**
 * @name serviceLPlusCP
 * @description Realiza o bootstrap do Leadster Plus no Control Panel, enviando os dados necessários
 * para inicialização do widget. Utiliza o token de autenticação do usuário para gerar os headers
 * da requisição e envia os dados de configuração para o endpoint de bootstrap.
 * @param {string} token - Token de autenticação do usuário no Control Panel.
 * @param {Object} data - Dados de configuração necessários para o bootstrap do Leadster Plus.
 * @returns {Promise} Promise com a resposta da API contendo as informações de bootstrap e base url.
 */
export const serviceLPlusCP = async (token, data) => {
  const headers = generateHeaders(token);

  return await api.post("/lplus/bootstrap", data, headers);
};

/**
 * @name serviceLPlusExternal
 * @description Realiza a troca de tokens com a API externa do Leadster Plus. Utiliza o bootstrap_jwt
 * obtido do Control Panel para solicitar novos tokens de acesso (access_token e refresh_token)
 * na API externa do Leadster Plus, permitindo a autenticação completa do widget.
 * @param {string} bootstrap_jwt - JWT de bootstrap obtido do Control Panel para troca de tokens.
 * @param {string} lplus_base_url - URL base da API externa do Leadster Plus.
 * @returns {Promise} Promise com a resposta da API externa contendo os tokens de acesso e atualização.
 */
export const serviceLPlusExternal = async (bootstrap_jwt, lplus_base_url) => {
  const headerExternal = {
    headers: {
      credentials: "include",
      Authorization: `Bearer ${bootstrap_jwt}`,
    },
  };

  // Normaliza a URL removendo trailing slash se existir e adiciona o path
  const normalizedUrl = lplus_base_url.endsWith("/")
    ? `${lplus_base_url}auth/exchange-tokens`
    : `${lplus_base_url}/auth/exchange-tokens`;

  return await axios.post(normalizedUrl, {}, headerExternal);
};

/**
 * @name validateLeadsterPlusMenuAccessService
 * @description Verify if the opportunity is allowed to access the Leadster Plus menu.
 * @param {params} - Object with the opportunity id number selected by the user.
 * @returns {Promise} Promise with the API response indicating if the access is allowed or not.
 */
export const validateLeadsterPlusMenuAccessService = async (params) =>
  await api.get(`/lplus/has-access/${params.opportunityId}`);
